import styled from "styled-components";
import { naira } from "../../../../utils/data";
import { ICON_ARROW_DOWN, ICON_EYE_FILL } from "../../../../utils/icons";
import { blue_circle } from "../../../../assets";


const BusinessAccount = () => {
      return (
            <StyledBusinessAccount>
                  <div className="main-container">
                        <div className="d-flex gap-3">
                              <div className="">
                                    <img src={blue_circle} alt="circle" width='100px' />
                              </div>
                              <div className="w-100">
                                    <h5 className="grey-bold-text mb-4">
                                          Business Account
                                    </h5>
                                    <small className="grey-text">
                                          Current Balance
                                    </small>
                                    <div className="d-flex gap-3 justify-content-between">
                                          <div className="">
                                                <h4 className="">
                                                      {naira}3,600,000.00
                                                </h4>
                                          </div>
                                          <div className="">
                                                <span className="me-3 h4">
                                                      {ICON_EYE_FILL}
                                                </span>
                                                <div className="badge badge-danger">
                                                      {ICON_ARROW_DOWN}
                                                      +3.43
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </StyledBusinessAccount>

      );
};

export default BusinessAccount;

const StyledBusinessAccount = styled.section`


`;